"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SearcherDateCarouselMobile["default"];
  }
});
var _SearcherDateCarouselMobile = _interopRequireDefault(require("./SearcherDateCarouselMobile"));